import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedScriptCard = ({ script, onView, onEdit, onDelete }) => {
  const getTypeIcon = (type) => {
    switch (type) {
      case 'sms':
        return 'MessageSquare';
      case 'email':
        return 'Mail';
      case 'call':
        return 'Phone';
      default:
        return 'FileText';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'sms':
        return 'var(--color-accent)';
      case 'email':
        return 'var(--color-primary)';
      case 'call':
        return 'var(--color-success)';
      default:
        return 'var(--color-muted-foreground)';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 hover:border-primary/50 transition-all duration-200">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
            <Icon name={getTypeIcon(script?.type)} size={20} color={getTypeColor(script?.type)} />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-foreground mb-1 truncate">{script?.title}</h4>
            <p className="text-xs text-muted-foreground line-clamp-2">{script?.situation}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4 mb-3 text-xs text-muted-foreground">
        <div className="flex items-center gap-1">
          <Icon name="Calendar" size={12} />
          <span>{script?.createdDate}</span>
        </div>
        <div className="flex items-center gap-1">
          <Icon name="Tag" size={12} />
          <span className="capitalize">{script?.industry}</span>
        </div>
        {script?.usageCount > 0 && (
          <div className="flex items-center gap-1">
            <Icon name="TrendingUp" size={12} />
            <span>Used {script?.usageCount}x</span>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" iconName="Eye" onClick={() => onView(script)}>
          View
        </Button>
        <Button variant="ghost" size="sm" iconName="Edit" onClick={() => onEdit(script)} />
        <Button variant="ghost" size="sm" iconName="Trash2" onClick={() => onDelete(script?.id)} />
      </div>
    </div>
  );
};

export default SavedScriptCard;